module.exports = __webpack_public_path__ + "static/media/slide1.eed8a720.jpg";